var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Parlement"},[_c('div',{staticClass:"Parlement__txt",domProps:{"innerHTML":_vm._s(_vm.msg)}})])}
var staticRenderFns = []

export { render, staticRenderFns }